
export default {
    name: 'AddressPicker',
    props: {
        /**
         * Array of user addresses
         */
        addresses: {
            type: Array,
            default() {
                return [];
            },
        },
        /**
         * A form object
         */
        form: {
            type: Object,
            required: true,
        },
        /**
         * Should we show the add address form?
         */
        showAddAddress: {
            type: Boolean,
            default: false,
        },
    },
    created() {
        if (this.addresses.length && !this.form.address?.$model?.id) {
            const primary = this.addresses.filter((checkAddress) => checkAddress.primary);
            if (primary.length) {
                this.useAddress(primary[0]);
            }
        }
    },
    methods: {
        toggleShow() {
            if (this.showAddAddress) {
                /* eslint vue/no-mutating-props: 0 */
                // @todo fix this
                this.form.addressLine1.$model = '';
                this.form.houseName.$model = '';
                this.form.postcode.$model = '';
            }
            this.$emit('toggle-show');
        },
        /**
         * Use event
         *
         * @type {object} - An Address Object
         */
        useAddress(address) {
            this.$emit('use', address);
            this.$emit('input', false);
        },
    },
};

